"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconELearningLaptop = /*#__PURE__*/
function (_Icon) {
  _inherits(IconELearningLaptop, _Icon);
  function IconELearningLaptop(props) {
    var _this;
    _classCallCheck(this, IconELearningLaptop);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconELearningLaptop).call(this, props));
    _this.name = 'IconELearningLaptop';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "e-learning-laptop_svg__group0"
    }, _react2.default.createElement("path", {
      className: "e-learning-laptop_svg__path0",
      d: "M20.5 15a.5.5 0 01-.5-.5V5.168c0-.311-.121-.604-.342-.825A1.156 1.156 0 0018.833 4H5.167C4.523 4 4 4.524 4 5.167V14.5a.5.5 0 01-1 0V5.168A2.17 2.17 0 015.167 3h13.666A2.17 2.17 0 0121 5.168V14.5a.5.5 0 01-.5.5z"
    }), _react2.default.createElement("path", {
      className: "e-learning-laptop_svg__path1",
      d: "M5.625 21a5.756 5.756 0 01-5.364-3.619 1.001 1.001 0 01.218-1.082c.189-.191.441-.297.71-.299h6.894c.432 0 .813.28.941.681C9.242 17.423 10.548 18 12 18s2.757-.574 2.972-1.308c.13-.408.519-.691.947-.692h6.891a1.007 1.007 0 01.931 1.38A5.757 5.757 0 0118.379 21H5.625zM1.19 17.002A4.754 4.754 0 005.622 20h12.755a4.76 4.76 0 004.436-2.993L15.924 17c-.353 1.158-1.999 2-3.924 2-1.92 0-3.563-.839-3.924-2H1.193l-.003.002z"
    }), _react2.default.createElement("path", {
      className: "e-learning-laptop_svg__path2",
      d: "M16.5 14.501c-1.103 0-2-.897-2-2 0-.36.096-.706.278-1.014l-1.042-1.042a3.002 3.002 0 01-1.737.556 3 3 0 01-1.737-.556L9.22 11.487c.184.308.28.654.28 1.014 0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2c.36 0 .707.096 1.015.279l1.041-1.042A3 3 0 019 8.001c0-1.654 1.346-3 3-3s3 1.346 3 3a3 3 0 01-.556 1.737l1.041 1.042a1.977 1.977 0 011.015-.279c1.103 0 2 .897 2 2s-.897 2-2 2zm0-3a1.001 1.001 0 000 2 1 1 0 000-2zm-9 0a1.001 1.001 0 101 1c0-.551-.449-1-1-1zm4.5-5.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
    })));
    return _this;
  }
  return IconELearningLaptop;
}(_Icon3.default);
exports.default = IconELearningLaptop;